export default {"src":"https://static.smartdeer.com/global/mkt/_next/static/media/location.f37a66e7.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};